import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

import { StatusChip } from "./StatusChip";
import DataGridTextHeader from "../../molecules/DataGridTextHeader";

export const insuranceInformationColumns: GridColDef[] = [
  {
    field: "transationDateTime",
    headerName: "Transaction Date/time",
    width: 170,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
    valueGetter: ({ value }) => value && dayjs(value).format("DD/MM/YYYY"),
  },
  {
    field: "type",
    headerName: "Type",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "transationName",
    headerName: "Transaction Name",
    width: 260,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "policyNumber",
    headerName: "Policy Number/ Client ID",
    width: 170,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "isStp",
    headerName: "STP/Non STP",
    width: 200,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "status",
    headerName: "Transaction Status",
    width: 130,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
    renderCell: item => StatusChip(item.row.transactionStatus),
  },
];
